import { render, staticRenderFns } from "./powerManage-list.vue?vue&type=template&id=65ec1131&scoped=true"
import script from "./powerManage-list.vue?vue&type=script&lang=js"
export * from "./powerManage-list.vue?vue&type=script&lang=js"
import style0 from "./powerManage-list.vue?vue&type=style&index=0&id=65ec1131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec1131",
  null
  
)

export default component.exports